<template>
  <div>
    <img :src="matrixUrl" alt="">
  </div>
</template>

<script>
import Canvas from '../../help/Canvas'
import Create from '../../service/create'
export default {
  mounted () {
    this.getMatrixUrl()
  },
  data() {
    return {
      matrixUrl: ''
    }
  },
  methods: {
    getMatrixUrl () {
      const mycanvas = new Canvas({
        bgWidth: 500,
        bgHeight: 500
      })
      const pics = [
        'https://cdnnft.ipfx.net/20220621/c152ee52240447119cdcaea48b49b257.jpg',
        'https://cdnnft.ipfx.net/20220621/c152ee52240447119cdcaea48b49b257.jpg',
        'https://cdnnft.ipfx.net/20220621/c152ee52240447119cdcaea48b49b257.jpg',
        'https://cdnnft.ipfx.net/20220621/c152ee52240447119cdcaea48b49b257.jpg',
        'https://cdnnft.ipfx.net/20220621/c152ee52240447119cdcaea48b49b257.jpg',
        'https://cdnnft.ipfx.net/20220621/c152ee52240447119cdcaea48b49b257.jpg',
        'https://cdnnft.ipfx.net/20220621/c152ee52240447119cdcaea48b49b257.jpg'
      ]
      mycanvas.run(pics).then(() => {
        return Create.uploadImgByBase64(mycanvas.print())
      }).then(res => {
        this.matrixUrl = res.fileUrl
      })
    }
  }
}
</script>